export const categories = {
	navTitle: "Catégories",
	title: "Catégories",
	subtitle: "Voir, réorganiser, créer et modifier vos catégories de produits.",
	searchPlaceholder: "Catégorie, sous-catégorie ou produit",
	addCategoryBtn: "Ajouter une catégorie",
	amountOfCategories_one: "{{count}} catégorie",
	amountOfCategories_other: "{{count}} catégories",
	filterByBtn: "Filtrer l'ordre",
	categoryEmptyState: {
		title: "Aucune catégorie trouvée",
		description: "Il n'y a pas encore de catégories enregistrées.",
	},
	subcategories_one: "{{count}} Sous-catégorie",
	subcategories_other: "{{count}} Sous-catégories",
	products_one: "{{count}} Produit",
	products_other: "{{count}} Produits",
	chartAccountName: "Plan comptable",
	noCategoryDescription: "Il n'y a pas encore de description pour cette catégorie.",
	addSubcategoryBtn: "Ajouter une sous-catégorie dans {{category}}",
	addProductBtn: "Ajouter un produit dans {{category}}",
	dialog: {
		create: {
			title: "Ajouter une catégorie",
			save: "Enregistrer la catégorie",
		},
		createSubcategory: {
			title: "Ajouter une sous-catégorie",
			save: "Enregistrer la sous-catégorie",
		},
		edit: {
			title: "Modifier la catégorie",
			delete: "Supprimer la catégorie",
			deleteTooltip: "Cette catégorie a des produits associés",
			save: "Enregistrer les modifications",
		},
		form: {
			name: {
				label: "Nom",
				placeholder: "Définir le nom de la catégorie",
				requiredName: "Le nom est requis",
			},
			priority: {
				label: "Position de priorité",
				tooltip: "Ordre dans lequel elle apparaîtra parmi les catégories.",
				placeholder: "Définir la position ou réorganiser dans la liste plus tard",
				requiredPriority: "Le niveau de priorité est requis",
			},
			printOrder: {
				label: "Phase de livraison",
				tooltip:
					"Catégorie pour le phasage automatique des cours.<br>L'opérateur pourra réorganiser au POS si nécessaire.",
				placeholder: "Assigner une phase automatique",
				requiredPrintOrder: "La phase de catégorie est requise",
				invalidPrintOrder: "Phase de catégorie invalide",
			},
			chartAccount: {
				label: "Plan comptable",
				tooltip: "Le plan comptable définit le compte comptable de la catégorie.",
				placeholder: "Sélectionner",
			},
			description: {
				label: "Description de la catégorie",
				placeholder: "Décrire la catégorie",
			},
		},
	},
	modal: {
		delete: {
			title: "Voulez-vous supprimer la catégorie ?",
			description:
				"Lors de la confirmation, la catégorie sera supprimée et l'action ne peut pas être annulée.",
			confirm: "Supprimer la catégorie",
			cancel: "Annuler",
		},
	},
	inputImage: {
		addImage: "Ajouter une image",
		infoTypeAndSize: "Type de fichier {{type}} jusqu'à {{size}}MB",
		infoOnlyType: "Type de fichier {{type}}",
	},
	productToOrg: {
		nameLabel: "Nom",
		kindLabel: "Type de produit",
		kindPlaceholder: "Sélectionner le type de produit",
		hasAlcoholLabel: "Contient de l'alcool",
		createDialogTitle: "Créer un produit",
		editDialogTitle: "Modifier un produit",
		createProductBtn: "Créer un produit",
		editProductBtn: "Modifier le produit",
	},
};
